import contentProvider, {
  SET_CONTENT,
  DEFAULT_VAL,
  Content,
  reducer,
  inject
} from './contentProvider';

export {
  contentProvider,
  SET_CONTENT,
  DEFAULT_VAL,
  Content,
  reducer,
  inject
};



/** WEBPACK FOOTER **
 ** ./client/shared/packages/contentProvider/src/index.js
 **/